import { render } from "./Newsletter.vue?vue&type=template&id=a9e82086&scoped=true"
import script from "./Newsletter.vue?vue&type=script&lang=js"
export * from "./Newsletter.vue?vue&type=script&lang=js"

import "./Newsletter.vue?vue&type=style&index=0&id=a9e82086&scoped=true&lang=css"
import "./Newsletter.vue?vue&type=style&index=1&id=a9e82086&scoped=true&lang=css"

import exportComponent from "C:\\Proyectos\\puerto-antioquia-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9e82086"]])

export default __exports__